class AccountSettings.InstagramListeningHashtagsView extends Backbone.View

  template: JST['backbone/templates/account_settings/topics/instagram_listening_hashtags']

  initialize:({activeHashtagsCountView, hashtagCreatorView, paginatedView})->
    @activeHashtagsCountView = activeHashtagsCountView
    @hashtagCreatorView = hashtagCreatorView
    @paginatedView = paginatedView
    @searchView = new AccountSettings.SearchView()
    @listenTo(@hashtagCreatorView, 'hashtag:added:one', @_newHashtagAdded)
    @listenTo(@searchView, 'hashtag:search:begin', @_searchHashtag)
    @listenTo(@searchView, 'hashtag:search:reset', @_resetSearchHashtag)
    @listenTo(@paginatedView, 'hashtag:count:changed', @_hashtagsCountChanged)

  render: ->
    @$el.html(@template())
    @$el.find('#hashtags-count-container').append(@activeHashtagsCountView.render().el)
    @$el.find('#hashtag-creator-container').append(@hashtagCreatorView.render().el)
    @$el.find('#hashtags-listening-table').append(@paginatedView .render().el)
    @$el.find('#search-container').append(@searchView.render().el)
    @

  _newHashtagAdded:(hashtag_search)->
    @paginatedView.render()

  _searchHashtag:(searchingText)->
    @paginatedView.setSearchingText(searchingText)
    @paginatedView.resetPagesNumber()
    @paginatedView.render()

  _resetSearchHashtag:->
    @paginatedView.resetSearchingText()
    @paginatedView.resetPagesNumber()
    @paginatedView.render()

  _hashtagsCountChanged:(hashtagsCount)->
    @activeHashtagsCountView.setCounts(hashtagsCount)
